// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import CourseTypeProxy from "@/proxies/CourseTypeProxy"

const state = {
  courseTypes: [],
  courseType: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new CourseTypeProxy(params).all()
    commit("SET_COURSE_TYPES", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new CourseTypeProxy(params).find(id)
    commit("SET_COURSE_TYPE", response)
  },

  async create(_, item) {
    return await new CourseTypeProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new CourseTypeProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new CourseTypeProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
